import { render, staticRenderFns } from "./reduceInsurer.vue?vue&type=template&id=f4eddeaa&scoped=true"
import script from "./reduceInsurer.vue?vue&type=script&lang=js"
export * from "./reduceInsurer.vue?vue&type=script&lang=js"
import style0 from "./reduceInsurer.vue?vue&type=style&index=0&id=f4eddeaa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4eddeaa",
  null
  
)

export default component.exports